import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToHashElement() {
  const location = useLocation();

  useEffect(() => {
const hash = location.hash?.replace("#", "");

if (!hash) {
  window.scrollTo({ top: 0, behavior: "auto" });
  return;
}

    const scrollToTarget = () => {
      const el = document.getElementById(hash);
      if (!el) return;

      const navbarOffset = 80;
      const y = el.getBoundingClientRect().top + window.pageYOffset - navbarOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    };

    const timer = setTimeout(scrollToTarget, 120);
    return () => clearTimeout(timer);
  }, [location]);

  return null;
}